import React, { useState, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import IconButton from '@material-ui/core/IconButton';
import DocumentsIcon from '../../assets/icons/DocumentIcon';
import FileIcon from '../../assets/icons/FileIcon';
import DeleteIcon from '../../assets/icons/DeleteIcon';

import DocumentsUploadModal from './modals/DocumentsUploadModal';
import ConfirmationModal from '../shared/modal/ConfirmationModal';
import AddButton from '../shared/AddButton';

import { onUploadComplete } from '../../actions/casesActions';

const CaseDocuments = (props) => {
  const { documents = [], preview, onDelete, onPreviewClick, caseId, tenantId, tenantColor, connectedTenantId } = props;
  const dispatch = useDispatch();

  const [isModalOpen, toggleModal] = useState(false);
  const [deleteModalOpen, toggleDeleteModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const onUpload = (fileName, downloadUrl) => {
    dispatch(onUploadComplete(caseId, { name: fileName, downloadUrl }, connectedTenantId));
  };

  const onFileClick = (url) => {
    window.open(url, '_blank');
  };

  const list = useMemo(() => {
    if (preview) {
      return documents.slice(0, 3);
    }
    return documents;
  }, [documents, preview]);

  const onDeleteClick = () => {
    if (selectedDocument) {
      onDelete(selectedDocument.id);
      toggleDeleteModal(false);
      setSelectedDocument(null);
    }
  };

  return (
    <div className='case-documents__container' style={preview && { marginTop: '16px' }}>
      <div className='d-flex space-between m-b-lg'>
        <div className='d-flex'>
          <DocumentsIcon color='var(--app-text)' />
          <div className='font-size-bg font-bold m-l-md'>
            Documents
          </div>
        </div>

        <AddButton onClick={() => toggleModal(true)} />
      </div>

      <div
        className={`case-documents-list__container ${preview ? 'pointer' : ''}`}
        onClick={onPreviewClick}
      >
        { documents && list.map((document) => (
          <div key={document.id} className='case-document'>
            <div
              className='d-flex pointer'
              onClick={() => onFileClick(document.downloadUrl)}
            >
              <FileIcon className='m-r-md' color='var(--app-text)' />
              {document.fileName}
            </div>
            { !preview && (
              <IconButton
                onClick={() => {
                  toggleDeleteModal(true);
                  setSelectedDocument(document);
                }}
                size='small'
              >
                <DeleteIcon color='#F53434' />
              </IconButton>
            )}
          </div>
        ))}
      </div>

      <DocumentsUploadModal
        open={isModalOpen}
        onClose={() => toggleModal(false)}
        caseId={caseId}
        tenantId={tenantId}
        tenantColor={tenantColor}
        onUploadComplete={onUpload}
      />

      <ConfirmationModal
        open={deleteModalOpen}
        onClose={() => toggleDeleteModal(false)}
        onSubmit={onDeleteClick}
        title="Are you sure you want to delete this document?"
        submitText="Delete"
      />
    </div>
  );
};

export default CaseDocuments;
